const ENV = {
    GTM_ID: 'GTM-WX2BGL',
}

export default ENV
